import {
  FunctionComponent,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react'
import styled, { css } from 'styled-components'
import config from '@config'

interface StyledImageProps {
  hasError: boolean
}

export interface TeamLogoProps {
  url: string
  name: string
}

const {
  backend: { imageUrl: backendImageUrl },
} = config

const StyledTeamLogo = styled.div`
  line-height: 0;
  min-height: 30px;
  width: 30px;
  display: grid;
  justify-items: center;
  align-items: center;
`

const StyledImage = styled.img<StyledImageProps>`
  ${({ hasError }) =>
    hasError &&
    css`
      display: none;
    `};
  width: auto;
  height: auto;
  max-width: 30px;
  max-height: 30px;
`

const TeamLogo: FunctionComponent<TeamLogoProps> = ({ url, name }) => {
  const [error, setError] = useState<boolean>(false)
  const imageRef = useRef<HTMLImageElement>(null)

  const onError = useCallback(() => {
    setError(true)
  }, [])

  useEffect(() => {
    const currentImage = imageRef.current
    currentImage?.addEventListener('error', onError)
    return () => {
      currentImage?.removeEventListener('error', onError)
    }
  }, [onError])

  const imageSource = `${backendImageUrl}${url}?ratio=free&imwidth=30`

  return (
    <StyledTeamLogo>
      {url ? (
        <StyledImage
          ref={imageRef}
          hasError={error}
          srcSet={`${imageSource}&imdensity=1 1x, ${imageSource}&imdensity=2 2x, ${imageSource}&imdensity=3 3x`}
          alt={name}
          width="30"
          height="30"
          loading="lazy"
        />
      ) : null}
    </StyledTeamLogo>
  )
}

export default TeamLogo
